(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  const initializePasswordLogin = () => {
    const dialog = document.getElementById('modal-login');
    const trigger = document.querySelector('[data-password-open]');
    if (!dialog || !trigger || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const open = () => {
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
    };
    trigger.addEventListener('click', open);
    dialog.querySelector('[data-password-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    });
    if (dialog.querySelector('[aria-invalid="true"]')) open();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePasswordLogin, { once: true });
  } else {
    initializePasswordLogin();
  }
  document.addEventListener('shopify:section:load', initializePasswordLogin);

  } catch(e) { console.error(e); }
})();
})();
